import React from 'react'
import {Link} from 'gatsby';
import Constants from '../../constatns';

const CaseStudiesSidebar = (props) => {
  const {title, description, effects, plan} = props
    return (
      <>
        <div className="case-studies-sidebar-sticky">
            <div className="case-studies-details-info">
                <div className="section-title">
                    <h1>{title}
                    </h1>
                </div>
                <p>
                    {description}
                </p>
			    <br/>
                <div className="widget-area pb-70">
                    <div className="widget widget_tag_cloud">
                        <h3 className="widget-title">できること・効果</h3>
                        <div className="tagcloud">
                            <span className={`badge badge-pill badge-${effects.includes(Constants.CAMPAIGN_EFFECTS.GET_EMAILS) ? 'blue' : 'light'}`}>メールアドレス取得</span>
                            <span className={`badge badge-pill badge-${effects.includes(Constants.CAMPAIGN_EFFECTS.GET_SNS_ACCOUNTS) ? 'blue' : 'light'}`}>SNSアカウント取得</span>
                            <span className={`badge badge-pill badge-${effects.includes(Constants.CAMPAIGN_EFFECTS.GET_FOLLOWERS) ? 'blue' : 'light'}`}>フォロワー増やす</span>
                            <span className={`badge badge-pill badge-${effects.includes(Constants.CAMPAIGN_EFFECTS.GET_HIGH_SPREAD) ? 'blue' : 'light'}`}>拡散力：大</span>
                            <span className={`badge badge-pill badge-${effects.includes(Constants.CAMPAIGN_EFFECTS.GET_MIDDLE_SPREAD) ? 'blue' : 'light'}`}>拡散力：中</span>
                            <span className={`badge badge-pill badge-${effects.includes(Constants.CAMPAIGN_EFFECTS.GET_FRIENDS) ? 'blue' : 'light'}`}>友達増やす</span>
                            <span className={`badge badge-pill badge-${effects.includes(Constants.CAMPAIGN_EFFECTS.GET_USER_INFO) ? 'blue' : 'light'}`}>ユーザー情報取得</span>
                            <span className={`badge badge-pill badge-${effects.includes(Constants.CAMPAIGN_EFFECTS.UGC) ? 'blue' : 'light'}`}>UGC</span>
                            <span className={`badge badge-pill badge-${effects.includes(Constants.CAMPAIGN_EFFECTS.SALE_PROMOTION) ? 'blue' : 'light'}`}>販促誘導</span>
                            <span className={`badge badge-pill badge-${effects.includes(Constants.CAMPAIGN_EFFECTS.CONNECT_LINE_BUSINESS) ? 'blue' : 'light'}`}>公式LINE連携</span>
                            <span className={`badge badge-pill badge-${effects.includes(Constants.CAMPAIGN_EFFECTS.REDUCE_UN_FOLLOW) ? 'blue' : 'light'}`}>フォロー解除抑制</span>
                            <span className={`badge badge-pill badge-${effects.includes(Constants.CAMPAIGN_EFFECTS.INCREASED_SALES) ? 'blue' : 'light'}`}>売上増</span>
                            <span className={`badge badge-pill badge-${effects.includes(Constants.CAMPAIGN_EFFECTS.GAIN_RECOGNITION) ? 'blue' : 'light'}`}>認知拡大</span>
                            <span className={`badge badge-pill badge-${effects.includes(Constants.CAMPAIGN_EFFECTS.GET_CUSTOMER_LEAD) ? 'blue' : 'light'}`}>リード獲得</span>
                            <span className={`badge badge-pill badge-${effects.includes(Constants.CAMPAIGN_EFFECTS.INCREASED_ENGAGEMENT) ? 'blue' : 'light'}`}>エンゲージメント強化</span>
                            <span className={`badge badge-pill badge-${effects.includes(Constants.CAMPAIGN_EFFECTS.CONNECT_WATCHING) ? 'blue' : 'light'}`}>視聴継続率向上</span>
                            <span className={`badge badge-pill badge-${effects.includes(Constants.CAMPAIGN_EFFECTS.RETENTION) ? 'blue' : 'light'}`}>リテンション</span>
                            <span className={`badge badge-pill badge-${effects.includes(Constants.CAMPAIGN_EFFECTS.INCREASED_VISIT_STORE) ? 'blue' : 'light'}`}>来店促進</span>
                        </div>
                    </div>
                    <div className="widget widget_tag_cloud">
                        <h3 className="widget-title">使用できる料金プラン</h3>
                        <div>
                            {plan}
                        </div>
                    </div>
                </div>
                <div className="btn-box">
                    <Link href="/signup" className="default-btn" style={{fontSize:'20px',width:'300px',paddingTop:'15px',paddingBottom:'15px'}}>
                        <i className="flaticon-right"></i>
                        アカウント登録はこちら <span ></span>
                    </Link>
                </div>
            </div>
        </div>
      </>
    )
};

export default CaseStudiesSidebar